export default __webpack_public_path__ + "static/media/absa-logo.c44af8f7.png";